// extracted by mini-css-extract-plugin
export default {"divPrint":"Tickets_divPrint__1HKKT"};